import gmx_zMixins            from '../../../../includes/Jmixins/zMixins'


// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData          from '../primitives/localData'

import set_Watching           from './set_Watching'
import set_Events             from './set_Events'
import set_LocalValues        from './set_LocalValues'
import set_Canvas             from './set_Canvas'
import set_Queries            from './set_Queries'
import set_Execution          from './set_Execution'

import draw_Database          from './draw_Database'
import draw_Diagram           from './draw_Diagram'
import draw_Stage             from './draw_Stage'

// Diagram
import inc_dia_Router         from './inc_Diagram/dia_Router'
import inc_dia_Actions        from './inc_Diagram/dia_Actions'

// Stage
import inc_stg_Router         from './inc_Stage/stg_Router'
import inc_stg_Actions        from './inc_Stage/stg_Actions'


// Table
import inc_tbl_Viewer         from './inc_Table/tbl_Viewer'
import inc_tbl_Router         from './inc_Table/tbl_Router'
import inc_tbl_Actions        from './inc_Table/tbl_Actions'

// Navigation
import inc_map_Router         from './inc_SiteMap/map_Router'
import inc_map_Action         from './inc_SiteMap/map_Action'
// Global
import gmx_openWindow         from './gmxs/openWindow'
import gmx_openPopup          from './gmxs/openPopup'
import gmx_datePicker         from './gmxs/datePicker'
import gmx_dropDown           from './gmxs/dropDown'
import gmx_inputBox           from './gmxs/inputBox'

export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,

    set_Watching,
    set_Events,
    set_LocalValues,
    set_Canvas,
    set_Queries,
    set_Execution,

    draw_Database,
    draw_Diagram,
    draw_Stage,

    // Stage
    inc_dia_Router,
    inc_dia_Actions,
    
    // Stage
    inc_stg_Router,
    inc_stg_Actions,

    // Table
    inc_tbl_Viewer,
    inc_tbl_Router,
    inc_tbl_Actions,
    
    // Navigation
    inc_map_Router,
    inc_map_Action,
    
    // Includes
    gmx_openWindow,
    gmx_openPopup,
    gmx_datePicker,
    gmx_dropDown,
    gmx_inputBox,
  ],

}
